import { useSearchParams } from 'react-router-dom';
// import { setGlobal } from '../../common/globals';

const MockPage = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  window.name = searchParams.get('isMock');

  return (
    <div>
      <p>Mock is set to: {window.name}</p>
      <a href='/'>Go to home page</a>
    </div>
  );
};

export default MockPage;
